import React, {useEffect, useState} from 'react';

const PDFDisplayer = ({file, height = '90vh'}) => {
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    let mounted = true;
    const checkFile = async () => {
      try {
        // Try HEAD first (lighter); fallback to GET if not allowed
        let res = await fetch(file, {method: 'HEAD'});
        if (res.status === 405) {
          res = await fetch(file, {method: 'GET'});
        }
        if (!mounted) return;
        setStatus(res.ok ? 'ok' : 'missing');
      } catch (e) {
        if (!mounted) return;
        setStatus('missing');
      }
    };
    checkFile();
    return () => {
      mounted = false;
    };
  }, [file]);

  const containerStyle = {
    width: '100%',
    height: height,
    border: 'none',
    borderRadius: '8px',
    overflow: 'hidden',
    backgroundColor: '#f5f5f5',
  };

  const messageStyle = {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: 20,
    color: '#333',
    fontSize: '1.6rem',
    fontWeight: 600,
  };

  return (
    <div style={containerStyle}>
      {status === 'ok' && (
        <iframe
          src={`${file}#toolbar=1&navpanes=0&scrollbar=1`}
          title="PDF Viewer"
          width="100%"
          height="100%"
          style={{border: 'none'}}
        />
      )}

      {status === 'checking' && (
        <div style={{...messageStyle, fontSize: '1rem', fontWeight: 500}}>
          Cargando documento...
        </div>
      )}

      {status === 'missing' && (
        <div style={messageStyle}>El archivo solicitado no existe.</div>
      )}
    </div>
  );
};

export default PDFDisplayer;
